import React, { useState, useEffect, useLayoutEffect, useRef, useContext } from 'react';
import reportSettingStyles from './ReportSettings.style';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import CloseIcon from '@material-ui/icons/Close';
import { useNavigate } from 'react-router-dom';
import RbTextField from './text-field/TextField.component';
import Schedule from './schedule-components/Schedule';
import { colors } from 'theme/color-palette';
import {
	getDateTime,
	getDatetimeFromCron,
	cronToDate,
	getEndDate,
	getTmplName,
	isCustomDataset
} from 'helper/utils';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import {
	getRefreshTime,
	resetScheduleReportError,
	canUserCreateReport as canUserCreateReportAction
} from './ReportSettings.actions';
import {
	resetUsersWithReportAccess,
	setReportListFilterValues
} from '../Dashboard/Dashboard.actions';
import Weekdays from './schedule-components/Weekdays';
import { UserPortalContext } from 'context/appcontext';
import BouncingDotsLoader from './library/BouncingDotsLoader';
import LoadingPage from '../LoadingPage/LoadingPage';
import RadioField from './radio-fields/Radio.component';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ErrorIcon from '@material-ui/icons/Error';
import EndReport from './end-report-component/EndReport.component';
import {
	REPORT,
	REPORT_FORMAT,
	SCHEDULE,
	NOTIFY,
	CREATE,
	UPDATE,
	COUNT_MSG,
	DAILY,
	WEEKLY,
	MONTHLY,
	QUARTERLY,
	LATER,
	CALCULATING,
	NOW,
	TODAY,
	REPORT_NAME_ERROR,
	REPORT_NAME_EXISTS,
	END_DATE_ERROR,
	SCHEDULE_ERROR,
	CSV_FILE_TYPE,
	XLXS_FILE_TYPE,
	CSV_ROWS_EXCEED,
	ZERO_ROWS,
	MAX_ROW_COUNT,
	MAX_CSV_ROW_COUNT,
	ZERO_ROWS_TOOLTIP,
	CSV_ROWS_EXCEED_TOOLTIP,
	BAD_CHARACTER_SET,
	Bogle_Light,
	CUSTOM,
	END_REPORT,
	OCCURRENCE_ERROR,
	DAYS,
	DISCARD,
	DISCARD_WARNING,
	SHARED,
	TIMED_OUT_COUNT,
	WARNING_TO_CHANGE_TO_CSV,
	WARNING_ROW_LIMIT_EXCEED,
	WARNING_MAX_REPORT_CREATION,
	BACK_WARN_NOTE,
	BACK_WARN_MSG,
	CONTINUE,
	CANCEL_BUTTON,
	REPORT_SETTINGS_ERROR_MSG,
	OK,
	CANNED_REPORT_LIST,
	VENDOR_SCORECARD_VALIDATING_REPORT,
	VENDOR_SCORECARD_VALIDATED_REPORT,
	VENDOR_SCORECARD_MAX_ROW_COUNT,
	VENDOR_SCORECARD_MAX_ROW_COUNT_TOOLTIP,
	VENDOR_SCORECARD_ROW_COUNT_TIMEOUT,
	STR_TMPT_LIST,
	REGISTER_SALES_LIST,
	BYPASS_ROWCOUNT_LIST,
	DC_TMPT_LIST,
	REPORT_NAME_MAX_LENGTH,
	BASIC,
	CHARTER,
	DAILY_SCHEDULE_TOOLTIP,
	BASIC_SSI_TOOLTIP_MAX_COUNT,
	BASIC_SSI_TOOLTIP_ALLOWED_TEMP,
	BASIC_SSI_TOOLTIP_INVALID_REPORT,
	CHARTER_TOOLTIP_MAX_COUNT,
	CHARTER_TOOLTIP_ALLOWED_TEMP,
	FY24_CANNED_REPORT_LIST,
	PIVOT_MTS_VALUE,
	ABC,
	REPORT_NAME,
	DRAFT_NAME,
	HISTORICAL_REPORT_OMNI
} from 'constants/constant';
import {
	AppBar,
	Box,
	Button,
	FormHelperText,
	Grid,
	IconButton,
	InputLabel,
	Toolbar,
	Tooltip,
	Typography,
	RadioGroup,
	Switch,
	useMediaQuery
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import SLA from './library/SLA';
import StyledRadioGroupComp from './library/StyledRadioGroupComp';
import { trackPageInfo, trackEventInfo } from 'helper/analytics';
import { EVENTS, PAGE_ID, ACTION_ON } from 'constants/tracker';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import ShareReport from 'components/Share-report/ShareReport';
import DialogBox from '../Shared/DialogBox';
import { editReport, getReportsListSuccess } from 'components/Dashboard/Dashboard.actions';
import { setSelectedTemplate } from 'components/Template/Template.actions';
import { FEATURES } from 'helper/basicFeatureFlag';
import CheckIcon from '@material-ui/icons/Check';
import { resetFirstTimeUsrStatus } from 'components/UserTour/Tour.action';
import {
	resetPivotOptions,
	resetRowCountObject,
	saveItemShareStatus
} from 'components/Preview/Preview.actions';
import { isCalFamily } from 'components/Preview/filter/FilterCondition';
import { deepClone } from 'helper/helper';
import { postData } from 'service/postData.service';
import { putData } from 'service/putData.service';
import APIURLPATH from 'constants/apiconstants';
import { getListFilterValues } from 'helper/helper';
import { BLOCKED_STATUS_CODE, setPXProperties } from 'helper/perimeterX';
import PreviewDialog from 'components/Shared/DialogBox';
import PerimeterXCaptcha from 'components/Shared/PerimeterXCaptcha';
import { hasPivotedColumn, hasTimeAcross } from '../Preview/Preview.utils';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import DynamicScheduling from './DynamicScheduling';
import { getStartAndEndDates } from 'helper/dateRange';
import { VENDOR_SCORECARD_2025_LIST } from 'constants/constant';
import { getFuzzyOptions } from 'helper/utils';
import { logUIError } from 'helper/logging';

const { ERROR } = colors;

function ReportSettings() {
	const ref = useRef(null);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const portalUserContext = useContext(UserPortalContext);
	const { userDetails, customerType, isStudent } = portalUserContext;
	const { companyName, userPersona, loginId } = userDetails?.result;
	const isSmallScreen = useMediaQuery('(max-width:360px)');
	const classes = reportSettingStyles({ isSmallScreen });
	const [file, setFile] = useState('.XLSX');
	const [isDisabled, setIsDisabled] = useState(true);
	const [reportDesc, setReportDesc] = useState('');
	const [isEmailOpted, setIsEmailOpted] = useState(true);
	const [scheduleType, setScheduleType] = useState('');
	const [reportName, setReportName] = useState('');
	const [weeksSelected, setWeeksSelected] = useState(CUSTOM);
	const [dateSelect, setDateSelect] = useState(getDateTime(customerType).date);
	const [selectQuarter, setSelectQuarter] = useState(1);
	const [selectedDate, setSelectedDate] = useState(getDateTime(customerType).datetime);
	const [btnSelected, setBtnSelected] = useState('once');
	const [cronExpression, setCronExpression] = useState();
	const [errorMsg, setErrorMsg] = useState(undefined);
	const [errorMsgDescription, setErrorMsgDescription] = useState(undefined);
	const [occurance, setOccurance] = useState(undefined);
	const [endReportType, setReportType] = useState('By');
	const [endDate, setEndDate] = useState(new Date());
	const [refreshTime, setRefreshTime] = useState(null);
	const [error, showError] = useState({
		reportName: false,
		description: false,
		frequency: false,
		eDate: false
	});
	const [weeks, setWeeks] = useState(DAYS);
	const [width, setWidth] = useState(100);
	const [shareReportShow, setShareReportShow] = React.useState(false);
	const [sharedWith, setSharedWith] = useState([]);
	const [showInviteDiscardMsg, setShowInviteDiscardMsg] = useState(false);
	// To differentiate `WarningDialog` comp. as Error Dialog or Warning Dialog
	const [openWarningDialog, setOpenWarningDialog] = useState(false);
	const [openErrorDialog, setOpenErrorDialog] = useState({ open: false, msg: '' });
	const [isLoading, setIsLoading] = useState(false);
	const rowCount = useSelector((state) => state.previewReducer.rowCount);
	const selectedListCount = useSelector((state) => state.previewReducer.selectedListCount);
	const menu = useSelector((state) => state.previewReducer.menu);
	const reportNameList = useSelector((state) => state.dashboardReducer.reportNameList);
	const reportsList = useSelector((state) => state.dashboardReducer.reportsList);
	const sharedList = useSelector((state) => state.dashboardReducer.sharedList);
	const calendarRollDim = useSelector((state) => state.dashboardReducer.calendarRollDim);
	const templateData = useSelector((state) => state.templateReducer.templateData);
	const selectedTemplate = useSelector((state) => state.templateReducer.selectedTemplate);
	const subTempDetails = useSelector((state) => state.templateReducer.subTempDetails);
	const selectedView = useSelector((state) => state.templateReducer.selectedView);
	const cannedReportData = useSelector((state) => state.templateReducer.cannedReportData);
	const customDatasetDetails = useSelector((state) => state.templateReducer.customDatasetDetails);
	const savedCustomDatasets = useSelector((state) => state.templateReducer.savedCustomDatasets);
	const selectedList = useSelector((state) => state.previewReducer.selectedList);
	const filterList = useSelector((state) => state.previewReducer.filterList);
	const uuid = useSelector((state) => state.previewReducer.uuid);
	const rowCountRequest = useSelector((state) => state.previewReducer.rowCountRequest);
	const reportRefreshTime = useSelector((state) => state.reportSettingsReducer.reportRefreshTime);
	const { canCreateAdhocReports, canCreateScheduledReports } = useSelector(
		(state) => state.reportSettingsReducer
	);
	const rowCountErrorCode = useSelector((state) => state.previewReducer.rowCountErrorCode);
	const isEditEnabled = useSelector((state) => state.dashboardReducer.isEditEnabled);
	const action = useSelector((state) => state.dashboardReducer.action);
	const editData = useSelector((state) => state.dashboardReducer.editData);
	const tabValue = useSelector((state) => state.dashboardReducer.tabValue);
	const reportTypeTabValue = useSelector((state) => state.dashboardReducer.reportTypeTabValue);
	const linkItemActivity = useSelector((state) => state.previewReducer.linkItemActivity);
	const { draftName, pivotOpts } = useSelector((state) => state.previewReducer);
	const [showCaptchaDialogErrorBox, setShowCaptchaDialogErrorBox] = useState(false);
	const [isDynamicSelected, setIsDynamicSelected] = useState(false);

	window._pxOnCaptchaSuccess = (isValid) => {
		if (isValid) {
			setShowCaptchaDialogErrorBox(false);
		}
	};

	const isReportBeingEdited = isEditEnabled && menu === 'Update';
	const {
		SCHEDULE_TODAY: scheduleToday,
		DISABLE_ROW_COUNT: disableRowCountForBasic,
		CAN_USER_CREATE_REPORT_CHECK: canUserCreateReportCheckEnabled,
		HIDE_REPORT_SHARING: hideReportSharing
	} = FEATURES[customerType].REPORT_SETTINGS_PAGE;
	const errorCodes = [rowCountErrorCode];

	const isCannedReport = CANNED_REPORT_LIST.includes(Number(selectedTemplate));

	const disableRowCount =
		disableRowCountForBasic && !STR_TMPT_LIST.includes(Number(selectedTemplate));

	useLayoutEffect(() => {
		setWidth(ref?.current?.offsetWidth);
	}, []);

	const handleBtnClick = (event) => {
		if (btnSelected === 'continuous' && event.target.value === 'once') {
			setBtnSelected('once');
		} else if (btnSelected === 'once' && event.target.value === 'continuous') {
			setBtnSelected('continuous');
		}
		setScheduleType('');
		setWeeksSelected(CUSTOM);
	};

	const handleBack = () => {
		/**
		 * isEditEnabled - save draft scenario (context menu -> create report)
		 */
		if (selectedTemplate === null || action === 'CREATE') {
			navigate('/');
			return;
		}
		const urlParam = new URLSearchParams(window.location.search);
		if (urlParam.get('quick')) {
			navigate('/rbtemplates');
			return;
		}
		// dispatch(resetScheduleReportError());
		navigate('/preview');
	};

	const handleClose = () => {
		// Set setIsWarning = true, so Dialog comp. will display as Warning
		setOpenWarningDialog(true);
	};

	const handleShare = () => {
		setShareReportShow(true);
	};

	const handleShareReportPanelClose = () => {
		if (sharedWith?.length > 0) {
			setShowInviteDiscardMsg(true);
		} else {
			setShowInviteDiscardMsg(false);
			setShareReportShow(false);
		}
	};

	const handleShareDiscard = () => {
		setShowInviteDiscardMsg(false);
		setShareReportShow(false);
		dispatch(resetUsersWithReportAccess());
	};

	const handleFiletypeChange = (event) => {
		setFile(event.target.value);
	};

	const handleFrequency = (event) => {
		setScheduleType(event.target.value);
		setSelectedDate(getDateTime(customerType).datetime);
		setDateSelect(getDateTime(customerType).date);
		showError({
			...error,
			frequency: false,
			eDate: false
		});
	};

	const isTimedOut = () => {
		if (rowCount === TIMED_OUT_COUNT && file === XLXS_FILE_TYPE) {
			return true;
		}
		return false;
	};

	const fileType = isCannedReport
		? [{ label: XLXS_FILE_TYPE, disabled: false, tooltip: null }]
		: [
				{ label: XLXS_FILE_TYPE, disabled: isTimedOut(), tooltip: null },
				{ label: CSV_FILE_TYPE, disabled: false, tooltip: null }
		  ];
	const runOnce = scheduleToday
		? [
				{ label: TODAY, disabled: false, tooltip: null },
				{ label: LATER, disabled: false, tooltip: null }
		  ]
		: [
				{ label: NOW, disabled: false, tooltip: null },
				{ label: LATER, disabled: false, tooltip: null }
		  ];

	const hasCommonItem = (arr1, arr2) => {
		const map = new Map();
		arr1.forEach((item) => map.set(item, true));
		return arr2.some((item) => map.has(item));
	};

	/**
	 *
	 * For daily and weekly pipeline having templates:
	 * If filter on a week is selected then we need to
	 * disable DAILY option from scheduling report
	 * and only one day from a week should be available for users to schedule report
	 */

	const isDailyOptionDisabled = () => {
		// Constants
		const predefinedWeeklyOptions = [
			'WMT Last week',
			'WMT Last 2 weeks',
			'WMT Last 4 weeks',
			'WMT Last 13 weeks',
			'WMT Last 26 weeks',
			'WMT Last 52 weeks'
		];

		const filterCondition = filterList.find((el) => el.dataType === 'date')?.filter?.condition;
		const mtsCustomDate1RangeType = filterList.find((el) => el.dataType === 'date')?.mts
			?.CUSTOM_DATE_1?.rangeType;
		const mtsCustomDate2RangeType = filterList.find((el) => el.dataType === 'date')?.mts
			?.CUSTOM_DATE_2?.rangeType;
		const mtsFilterCondition = () => {
			if (
				isMts() &&
				filterList.find((el) => el.dataType === 'date')?.filter &&
				filterList.find((el) => el.dataType === 'date')?.filter?.condition
			) {
				return filterList.find((el) => el.dataType === 'date')?.filter?.condition;
			} else {
				return '';
			}
		};

		// Methods
		const isWeekFilterCustom = () => {
			return (
				filterList.find((el) => el.dataType === 'date') &&
				filterList.find((el) => el.dataType === 'date').businessName === 'Week' &&
				filterList.find((el) => el.dataType === 'date').filter?.condition === 'Custom'
			);
		};

		const isWeekFilterPredefined = () => {
			return (
				filterList.find((el) => el.dataType === 'date') &&
				isHavingPredefinedWeeklyOptions(filterCondition)
			);
		};

		// const isDataTypeEqDate = () => filterList.find((el) => el.dataType === 'date');
		const isMts = () => filterList.find((el) => el.dataType === 'date')?.mts;
		const isMtsCustomDate1 = () =>
			filterList.find((el) => el.dataType === 'date')?.mts?.CUSTOM_DATE_1;
		const isMtsCustomDate2 = () =>
			filterList.find((el) => el.dataType === 'date')?.mts?.CUSTOM_DATE_2;
		const isHavingPredefinedWeeklyOptions = (conditionString) => {
			// Convert the string to array
			const conditionsArray = conditionString.split(',');

			// Check if the conditions array is having one of the predefined weekly options
			return hasCommonItem(conditionsArray, predefinedWeeklyOptions);
		};

		const isMtsCustomDateRange1TypeEqWeek = () => mtsCustomDate1RangeType === 'week';
		const isMtsCustomDateRange2TypeEqWeek = () => mtsCustomDate2RangeType === 'week';
		const isMtsHavingPredefinedWeek = () => {
			return isHavingPredefinedWeeklyOptions(mtsFilterCondition());
		};
		// Logic
		// Step 1 (Is Weekly Filter Selected (Custom or Predefined) ?
		if (isWeekFilterCustom() || isWeekFilterPredefined()) {
			return true;
			// Step 2 (Is MTS selected ?)
		} else if (isMts()) {
			// Step 3 (Is MTS having any weekly predefined conditions ?)
			if (isMtsHavingPredefinedWeek()) {
				return true;
			} else {
				// Step 4 (Is MTS having custom week range ?)
				if (
					(isMtsCustomDate1() && isMtsCustomDateRange1TypeEqWeek()) ||
					(isMtsCustomDate2() && isMtsCustomDateRange2TypeEqWeek())
				) {
					return true;
				} else {
					return false;
				}
			}
		} else {
			return false;
		}
	};

	/**
	 * If canned report is being scheduled/edited then don't show daily option
	 */
	const runContinously = isCannedReport
		? [
				{ label: WEEKLY, disabled: false, tooltip: null },
				{ label: MONTHLY, disabled: false, tooltip: null },
				{ label: QUARTERLY, disabled: false, tooltip: null }
		  ]
		: [
				{
					label: DAILY,
					disabled: isDailyOptionDisabled(),
					tooltip: isDailyOptionDisabled()
						? { text: DAILY_SCHEDULE_TOOLTIP, placement: 'bottom-start' }
						: null
				},
				{ label: WEEKLY, disabled: false, tooltip: null },
				{ label: MONTHLY, disabled: false, tooltip: null },
				{ label: QUARTERLY, disabled: false, tooltip: null }
		  ];

	const renderSchedules = (val) => {
		if (val === 'once') {
			return (
				<RadioGroup
					aria-label="once-group"
					name="once-group"
					row
					id="once-group"
					value={scheduleType}
					onChange={handleFrequency}>
					<RadioField item={runOnce} />
				</RadioGroup>
			);
		} else {
			return (
				<RadioGroup
					aria-label="continuous-group"
					name="continuous-group"
					row
					id="continuous-group"
					value={scheduleType}
					onChange={handleFrequency}>
					<RadioField item={runContinously} />
				</RadioGroup>
			);
		}
	};

	const handleReportName = (e) => {
		const value = e.target.value;
		if (ReportSettings.matcher.test(value)) {
			setErrorMsg(BAD_CHARACTER_SET);
			showError({
				...error,
				reportName: true
			});
		} else {
			// Enable the Create button if reportName is valid.
			if (isDisabled && value.length <= REPORT_NAME_MAX_LENGTH && !isTimedOut()) {
				setIsDisabled(false);
				// Reset the error in Store
				if (errorCodes.includes(505) || errorCodes.includes(400)) {
					dispatch(resetScheduleReportError());
				}
			}
			setReportName(value);
			setErrorMsg(undefined);
			if (value !== '') {
				showError({
					...error,
					reportName: false
				});
			}
		}
	};

	const handleReportDesc = (e) => {
		const value = e.target.value;
		if (ReportSettings.matcher.test(value)) {
			setErrorMsgDescription(BAD_CHARACTER_SET);
			showError({
				...error,
				description: true
			});
		} else {
			showError({
				...error,
				description: false
			});
			setReportDesc(e.target.value);
		}
	};

	const checkReportName = (val) => {
		let reportAttr = REPORT_NAME;
		if (reportTypeTabValue === 1) {
			reportAttr = DRAFT_NAME;
		}
		const reportName = val.toLowerCase();
		if (reportNameList.includes(reportName)) {
			if (
				isEditEnabled &&
				menu === 'Update' &&
				reportName === editData?.[reportAttr]?.toLowerCase()
			) {
				return;
			}
			setErrorMsg(REPORT_NAME_EXISTS);
			showError({
				...error,
				reportName: true
			});
			return true;
		}
	};

	const checkEndDate = () => {
		if ([NOW, LATER, TODAY].includes(scheduleType)) {
			return false;
		}
		if (endReportType === 'After' && ['', '0', undefined, null].includes(occurance)) {
			return true;
		}
		if (endReportType === 'By' && moment(endDate).isSame(moment().startOf('day'), 'd')) {
			return true;
		}
		return false;
	};

	const callPostApi = async (URL, reqBody) => {
		const request = { companyName, loginId };
		request['requestBody'] = reqBody;
		setIsLoading(true);
		let response;
		try {
			response = await postData(URL, request);
			setIsLoading(false);
			if (response.statusCode >= 400) {
				// Need to handle error scenio
				if (response.statusCode === BLOCKED_STATUS_CODE) {
					// Analytics
					trackEventInfo({
						type: EVENTS.BOT_DETECTION,
						actionOn: ACTION_ON.BOT_DETECTION,
						location: PAGE_ID.REPORT_SETTINGS
					});
					setPXProperties(response.data);
					setShowCaptchaDialogErrorBox(true);
				} else {
					logUIError(
						request,
						'ReportSettings',
						URL,
						JSON.stringify(request),
						response ? JSON.stringify(response) : 'No response'
					);
					setOpenErrorDialog({
						open: true,
						msg: response?.json?.details?.[0] || REPORT_SETTINGS_ERROR_MSG
					});
				}
				return;
			}

			// on Success
			const _list = [response?.json, ...reportsList];
			const _ret = {
				reportsList: _list,
				sharedList: sharedList,
				reportNameList: [response?.json.reportName.toLowerCase(), ...reportNameList]
			};
			resetReducers(_ret, _list);
		} catch (error) {
			logUIError(
				request,
				'ReportSettings',
				URL,
				JSON.stringify(request),
				response ? JSON.stringify(response) : 'No response'
			);
			setIsLoading(false);
		}
	};

	const callPutApi = async (URL, reqBody) => {
		const request = { companyName, loginId };
		request['requestBody'] = reqBody;
		setIsLoading(true);
		const response = await putData(URL, request);
		setIsLoading(false);
		if (response.statusCode >= 400) {
			// Need to handle error scenio
			if (response.statusCode === BLOCKED_STATUS_CODE) {
				// Analytics
				trackEventInfo({
					type: EVENTS.BOT_DETECTION,
					actionOn: ACTION_ON.BOT_DETECTION,
					location: PAGE_ID.REPORT_SETTINGS
				});
				setPXProperties(response.data);
				setShowCaptchaDialogErrorBox(true);
			} else {
				logUIError(
					request,
					'ReportSettings',
					URL,
					JSON.stringify(request),
					response ? JSON.stringify(response) : 'No response'
				);
				setOpenErrorDialog({
					open: true,
					msg: response?.json?.details?.[0] || REPORT_SETTINGS_ERROR_MSG
				});
			}
			return;
		}

		// on Success
		let _list = deepClone(reportsList);
		let _nameList = deepClone(reportNameList);

		const idToUpdate = reqBody.reportId;
		const nameToUpdate = reqBody.reportName;

		const listIdx = _list.findIndex((el) => el.reportId === idToUpdate);
		const nameIdx = _nameList.findIndex((el) => el.toLowerCase() === nameToUpdate.toLowerCase());
		_list.splice(listIdx, 1);
		_nameList.splice(nameIdx, 1);

		_list = [response?.json, ..._list];
		const _ret = {
			reportsList: _list,
			sharedList: sharedList,
			reportNameList: [response?.json.reportName.toLowerCase(), ..._nameList]
		};
		resetReducers(_ret, _list);
	};

	const resetReducers = (retObj, _pList) => {
		dispatch(editReport({ isEditEnabled: false, editData: {} }));
		dispatch(setSelectedTemplate({ templateId: null, view: null, filter: undefined }));
		dispatch(getReportsListSuccess(retObj));
		dispatch(setReportListFilterValues(getListFilterValues(_pList)));
		// dispatch(saveScheduleReportSuccess(response?.json));
		// dispatch(createReportSuccessful());
		dispatch(resetRowCountObject());
		dispatch(resetPivotOptions());
		navigate('/');
	};

	const getSelectedDate = () => {
		/**
		 * For basic users, if user selects to schedule a report for later then we want fixed time of 6.00pm utc on selected date
		 */
		if (customerType === BASIC) {
			const _cstLocalDtTime = moment(selectedDate).clone().tz('America/Chicago');
			const newDtTime = _cstLocalDtTime.set('hour', 13).set('minute', 0).set('second', 0);
			let offset = newDtTime.utcOffset();
			let utcDt = newDtTime.add(-offset, 'minute');
			utcDt = utcDt.format();
			utcDt = moment.parseZone(utcDt).utc(true).format();
			return utcDt;
		}
		return new Date(selectedDate);
	};

	const handleScheduleCreate = () => {
		if (!isLoading) {
			const isReportName = reportName === '' || checkReportName(reportName);
			const isFrequency = scheduleType === '' || scheduleType === undefined;
			const isEndDate = checkEndDate();
			let localErrorMsg;
			if (reportName === '') {
				setErrorMsg(REPORT_NAME_ERROR);
				localErrorMsg = REPORT_NAME_ERROR;
			} else if (checkReportName(reportName)) {
				setErrorMsg(REPORT_NAME_EXISTS);
				localErrorMsg = REPORT_NAME_EXISTS;
			} else {
				setErrorMsg(undefined);
				localErrorMsg = undefined;
			}

			showError({
				reportName: isReportName,
				frequency: isFrequency,
				eDate: isEndDate
			});

			if (
				selectedTemplate === null ||
				isReportName ||
				isFrequency ||
				[REPORT_NAME_EXISTS, REPORT_NAME_ERROR].includes(localErrorMsg) ||
				error.frequency ||
				isEndDate
			) {
				return;
			}
			// For disabled Row Count scenario, this would by pass(Ex: Basic user)
			if (rowCount > MAX_ROW_COUNT && file === XLXS_FILE_TYPE && !disableRowCount) {
				return;
			}

			if (isEndDate && runContinously.map((item) => item.label).includes(scheduleType)) {
				return;
			}

			let pivotColumn = null;
			if (hasPivotedColumn(pivotOpts?.pivotColumn)) {
				pivotColumn = pivotOpts?.pivotColumn;
				if (pivotOpts?.isMultiWeek) {
					// Since we are changing the pivotColumn value to wm_time_window_week, when we pull the data from BE
					// in Edit mode, the technicalName doesnt match, so hardcoding is required to check whether it is happening.
					// Reference: shouldCheck function in StoreTimeElements.component.js
					/**
					 * While applying Pivot on Single Time Attributes,
					 * if Walmart Calendar > Week is checked & multiple weeks are selected as filters, then pass the MTS value to BE
					 */
					pivotColumn = PIVOT_MTS_VALUE;
				}
			}

			let isTimeAcrossDataDown =
				hasPivotedColumn(pivotOpts?.pivotColumn) && hasTimeAcross(pivotOpts);

			const allData = [...templateData, ...cannedReportData];
			const isCustomDS = isCustomDataset(selectedTemplate);
			const isExistingCustomDS = selectedTemplate !== -1 && isCustomDS;
			let result = [...allData];
			if (isCustomDS) {
				result = allData.filter((item) => item?.view === ABC);
			} else {
				result = allData.filter((item) => item.templateName === getTmplName(selectedTemplate));
			}
			const modifiedTemplateId = isCustomDS
				? Number(customDatasetDetails?.templateId)
				: result[0]?.templateId;
			let existingCustomDs = {};
			if (isExistingCustomDS) {
				existingCustomDs = savedCustomDatasets.find(
					(template) => template?.customDatasetId === selectedTemplate
				);
			}
			let templateName = result[0]?.templateName;
			if (isExistingCustomDS) {
				templateName = existingCustomDs?.customDatasetName;
			}
			const scheduleRequest = {
				isRunAfterRefresh: isDynamicSelected,
				cronExpression: cronExpression,
				templateName: templateName,
				templateId: modifiedTemplateId,
				reportName: reportName?.trim(),
				uuid: uuid,
				frequency: scheduleType,
				scheduleStartDate: scheduleType === LATER ? getSelectedDate() : new Date(),
				fileType: file?.toLowerCase(),
				reportDesc: reportDesc,
				isEmailOpted: isEmailOpted,
				rowCount: rowCount,
				columns: selectedList?.map((item) => item.businessName),
				runQueryRequestObject: rowCountRequest,
				subTemplateId: subTempDetails?.subTemplateId,
				isStudent: isStudent,
				scheduleEndDate: [NOW, LATER, TODAY].includes(scheduleType) ? null : handleEndReport(),
				reportType: userPersona,
				noOfRuns: occurance === undefined ? 0 : occurance,
				filtersWithValue: filterList?.map((item) => {
					/**
					 * Need to update time range to show on metadata for old reports.
					 */
					if (isCalFamily(item)) {
						const conditionList = item.filter.condition.split(',');
						if (
							conditionList.length === 1 &&
							!conditionList.includes(CUSTOM) &&
							item.filter.condition !== ''
						) {
							const _item = deepClone(item);
							const isWMTCal = item?.parent?.substring(0, 3) === 'Wal';
							const hasValidExtraValArray = Array.isArray(item.filter.extraValue);
							const filteredFuzzyOption = getStartAndEndDates(
								item.filter.condition,
								getFuzzyOptions(),
								isWMTCal,
								calendarRollDim
							);
							if (
								!hasValidExtraValArray ||
								(hasValidExtraValArray && item.filter.extraValue.length != 2) ||
								(hasValidExtraValArray && isReportBeingEdited)
							) {
								const start = moment(filteredFuzzyOption?.weekStartDate).format('MM/DD/YYYY');
								const end = moment(filteredFuzzyOption?.weekEndDate).format('MM/DD/YYYY');
								_item.filter['extraValue'] = [start, end];
							}
							_item.type = item.dataType;
							return _item;
						}
					}
					return {
						...item,
						type: item.dataType
					};
				}),
				timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				sharedWith: sharedWith,
				linkItemActivity: linkItemActivity,
				pivotColumn,
				isTimeAcrossDataDown
			};

			if (isExistingCustomDS) {
				scheduleRequest.customDatasetId = existingCustomDs?.customDatasetId;
			}

			if (isReportBeingEdited) {
				const updatedRequest = {
					...scheduleRequest,
					reportId: editData['reportId']
				};
				const frequency = updatedRequest.cronExpression === '@once' ? 'Once' : 'Scheduled';
				let btnNameForTracking =
					tabValue === SHARED ? ACTION_ON.DUPLICATE_SHARED_REPORT : ACTION_ON.DUPLICATE_REPORT;
				if (menu !== 'Update') {
					btnNameForTracking = ACTION_ON.EDIT_REPORT_BUTTON;
				}

				trackEventInfo({
					type: EVENTS.CLICK,
					actionOn: `${btnNameForTracking} ${frequency} ${updatedRequest.fileType}`,
					location: PAGE_ID.REPORT_SETTINGS
				});
				if (updatedRequest.sharedWith?.length > 0) {
					trackEventInfo({
						type: EVENTS.CLICK,
						actionOn: `${ACTION_ON.SHARE_REPORT_BUTTON} while ${btnNameForTracking}`,
						location: PAGE_ID.REPORT_SETTINGS
					});
				}
				if (isCustomDS) {
					trackEventInfo({
						type: EVENTS.CLICK,
						actionOn: ACTION_ON.CUSTOM_DATASET_UPDATE_REPORT,
						location: PAGE_ID.REPORT_SETTINGS
					});
				}
				// dispatch(updateScheduleReport({ requestBody: updatedRequest, companyName }));
				callPutApi(APIURLPATH.SCHEDULE_UPDATE, updatedRequest, 'PUT');
			} else {
				if (reportTypeTabValue === 1) {
					scheduleRequest.reportId = editData['draftId'];
					// if user selected Saved tab on dashboard page and then came here via "New Report"
					scheduleRequest.reportType = editData['reportType'] || userPersona;
				}
				const frequency = scheduleRequest.cronExpression === '@once' ? 'Once' : 'Scheduled';
				trackEventInfo({
					type: EVENTS.CLICK,
					actionOn: `${ACTION_ON.CREATE_REPORT_BUTTON} ${frequency} ${scheduleRequest.fileType}`,
					location: PAGE_ID.REPORT_SETTINGS
				});
				if (scheduleRequest.sharedWith?.length > 0) {
					trackEventInfo({
						type: EVENTS.CLICK,
						actionOn: `${ACTION_ON.SHARE_REPORT_BUTTON} while ${ACTION_ON.CREATE_REPORT_BUTTON}`,
						location: PAGE_ID.REPORT_SETTINGS
					});
				}
				// Analytics
				if (isCustomDS) {
					trackEventInfo({
						type: EVENTS.CLICK,
						actionOn: ACTION_ON.CUSTOM_DATASET_CREATE_REPORT,
						location: PAGE_ID.REPORT_SETTINGS
					});
				}
				// dispatch(saveScheduleReport({ requestBody: scheduleRequest, companyName }));
				callPostApi(APIURLPATH.SCHEDULE_SAVE, scheduleRequest, 'POST');
			}
		}
		dispatch(saveItemShareStatus({ prev: false, curr: false }));
	};

	useEffect(() => {
		if (!isEditEnabled) {
			setWeeksSelected(CUSTOM);
		}
	}, [scheduleType]);

	useEffect(() => {
		let hasError =
			errorCodes.includes(505) ||
			errorCodes.includes(400) ||
			(Object.values(weeks).every((day) => !day) &&
				scheduleType === 'Weekly' &&
				weeksSelected === CUSTOM);

		if (disableRowCount) {
			// For disabled row count scenario (Ex: Basic user), the other following rowCount checks should be bypassed
			// and create button become disabled and then from here the execution is returned (if there's error)
			// Also, if report creation is reached max limit, (canCreateAdhocReports = false OR canCreateScheduledReports = false)
			// disable submit(Create) button (and show the warning message)
			let createShouldDisabled = false;
			if (
				(!canCreateAdhocReports && btnSelected === 'once') ||
				(!canCreateScheduledReports && btnSelected === 'continuous')
			) {
				createShouldDisabled = true;
			}
			const createReportHasError = canUserCreateReportCheckEnabled && createShouldDisabled;
			hasError = hasError || Object.values(error).some((value) => value) || createReportHasError;
			if (hasError) {
				setIsDisabled(true);
			} else {
				setIsDisabled(false);
			}
			return;
		}

		let disableCreateButton = !rowCount || rowCount === 0;
		// For Fuzzy Template like SSI, zero rowCount value condition will not disable the create button
		const bypassRowCount =
			BYPASS_ROWCOUNT_LIST.includes(Number(selectedTemplate)) || isCustomDataset(selectedTemplate);
		if (bypassRowCount) {
			disableCreateButton = false;
		}

		if (
			(rowCount > MAX_ROW_COUNT && file === XLXS_FILE_TYPE) ||
			(isTimedOut() && !isCannedReport) ||
			rowCount > MAX_CSV_ROW_COUNT ||
			disableCreateButton ||
			hasError
		) {
			setIsDisabled(true);
		} else {
			setIsDisabled(false);
		}
		// For Run once, isDynamicSelected should be false always.
		if (btnSelected === 'once') {
			setIsDynamicSelected(false);
		}
	}, [
		rowCount,
		file,
		weeks,
		scheduleType,
		weeksSelected,
		btnSelected,
		canCreateAdhocReports,
		canCreateScheduledReports
	]);

	useEffect(() => {
		trackPageInfo(PAGE_ID['REPORT_SETTINGS']);
		if (selectedTemplate === null) {
			navigate('/rbtemplates');
		}
		if (canUserCreateReportCheckEnabled) {
			dispatch(
				canUserCreateReportAction({
					companyName
				})
			);
		}
		if (draftName) {
			setReportName(draftName);
		}
	}, []);

	useEffect(() => {
		const weekMonthQuarterYear = ['Week', 'Month', 'Quarter', 'Year'];
		const nonDateFilter = filterList.find((el) => weekMonthQuarterYear.includes(el.businessName));
		const isWeekSel = nonDateFilter && nonDateFilter.filter.condition !== '';
		const isDateColumnSel = selectedList?.find((column) => column.businessName === 'Date');

		if (
			isWeekSel &&
			[
				...STR_TMPT_LIST,
				...DC_TMPT_LIST,
				...REGISTER_SALES_LIST,
				...HISTORICAL_REPORT_OMNI
			].includes(Number(selectedTemplate)) &&
			!isDateColumnSel
		) {
			setRefreshTime(reportRefreshTime.refreshTimeWeekly);
			return;
		}
		setRefreshTime(reportRefreshTime.refreshTime);
	}, [
		filterList,
		selectedTemplate,
		reportRefreshTime,
		reportRefreshTime?.refreshTimeWeekly,
		reportRefreshTime?.refreshTime,
		selectedList
	]);

	useEffect(() => {
		if (selectedTemplate !== null) {
			const allData = [...templateData, ...cannedReportData];
			const result = allData.filter((item) => item.templateName === getTmplName(selectedTemplate));
			// const isWeekSel = filterList?.some((el) => el.businessName === 'Week');
			if (result[0]?.view?.length > 0) {
				dispatch(
					getRefreshTime({
						requestBody: {
							templateName: getTmplName(selectedTemplate),
							identifier: userPersona
						}
					})
				);
			}
		}
	}, [templateData, cannedReportData, selectedTemplate]);

	useEffect(() => {
		if (errorCodes.includes(505) || errorCodes.includes(400)) {
			setOpenErrorDialog({ open: true, msg: REPORT_SETTINGS_ERROR_MSG });
		}
	}, [rowCountErrorCode]);

	useEffect(() => {
		if (isEditEnabled) {
			if (reportTypeTabValue === 0) {
				const rName = menu !== 'Update' ? `Copy Of ${editData.reportName}` : editData.reportName;
				checkReportName(rName);
				const endReportCheck = [0, undefined, null].includes(editData.noOfRuns);
				setReportName(rName);
				setReportDesc(editData.reportDesc);
				setIsEmailOpted(editData.isEmailOpted);
				setFile(editData.fileType?.toUpperCase());
				setBtnSelected([NOW, LATER, TODAY].includes(editData.frequency) ? 'once' : 'continuous');
				setCronExpression(editData.cronExpression);
				setScheduleType(editData.frequency);
				setReportType(endReportCheck ? 'By' : 'After');
				setOccurance(endReportCheck ? undefined : editData.noOfRuns);
				setEndDate(
					endReportCheck && editData.scheduleEndDate
						? moment.utc(editData.scheduleEndDate).local().format('YYYY/MM/DD HH:mm:ss')
						: new Date()
				);
				const fetchCronDetails = cronToDate(editData.cronExpression);
				if (fetchCronDetails) {
					const { hour, date, month, week, weekSelected, quarter } = fetchCronDetails;
					setWeeksSelected(weekSelected ? weekSelected : CUSTOM);

					if (weekSelected === CUSTOM) {
						Object.keys(weeks).forEach((key) => {
							if (week.includes(key.toLowerCase())) {
								weeks[key] = true;
							} else {
								weeks[key] = false;
							}
						});
					}
					setSelectQuarter(quarter);
					const datesFromCron = getDatetimeFromCron(
						hour,
						date,
						month,
						editData.frequency,
						editData.scheduleStartDate
					);
					setDateSelect(datesFromCron.date);
					setSelectedDate(datesFromCron.datetime);
					setSharedWith(menu !== 'Update' ? [] : editData.sharedWith);
				}
			} else {
				const rName = menu !== 'Update' ? `Copy Of ${editData.draftName}` : editData.draftName;
				checkReportName(rName);
				setReportName(rName);
			}
		}
	}, [isEditEnabled]);

	const bouncer = rowCount === undefined ? <BouncingDotsLoader /> : null;

	const checkMark =
		rowCount !== undefined && rowCount !== -1 && isCannedReport ? (
			<CheckIcon className={classes.checkMarkIcon} />
		) : null;

	const getButtonName = () => {
		return isReportBeingEdited ? UPDATE : CREATE;
	};

	const handleEndReport = () => {
		let eDate;
		if (endReportType === 'By') {
			eDate = moment.utc(endDate).local().format('YYYY/MM/DD');
		} else {
			eDate = getEndDate(occurance, scheduleType);
		}
		const formatDate = `${eDate} 23:59:00`;
		return new Date(formatDate);
	};

	const showRowCountMsg = () => {
		if (rowCount === undefined) {
			if (
				isCannedReport ||
				(customerType === BASIC && STR_TMPT_LIST.includes(Number(selectedTemplate)))
			) {
				return VENDOR_SCORECARD_VALIDATING_REPORT;
			}
			return COUNT_MSG;
		}

		if (rowCount === TIMED_OUT_COUNT) {
			return '--';
		}

		const prefix = rowCount > 1 ? 's' : '';
		if (
			isCannedReport ||
			(customerType === BASIC && STR_TMPT_LIST.includes(Number(selectedTemplate)))
		) {
			return `${VENDOR_SCORECARD_VALIDATED_REPORT} `;
		}
		return `${rowCount} Row${prefix}, ${selectedListCount} Columns `;
	};

	const WarnMsg = () => {
		if (disableRowCount) {
			// If row count check is disabled and the user(for ex: Basic user) selects xlsx type,
			// following warning should be shown, else no message to show.
			if (file === XLXS_FILE_TYPE) {
				return (
					<Typography
						style={{
							size: 14,
							paddingBottom: 10,
							paddingLeft: 12,
							lineHeight: '20px',
							font: 'Bogle',
							color: '#6D6E71',
							fontWeight: 400
						}}>
						{WARNING_ROW_LIMIT_EXCEED}
					</Typography>
				);
			}
			return null;
		}

		if (!isTimedOut()) {
			return null;
		}
		return (
			<Alert severity="error" className={classes.warnMsg} variant="outlined">
				{isCannedReport ? VENDOR_SCORECARD_ROW_COUNT_TIMEOUT : WARNING_TO_CHANGE_TO_CSV}
			</Alert>
		);
	};

	const cbOnWaningDialogOkay = () => {
		dispatch(editReport({ isEditEnabled: false, editData: {}, action: null }));
		dispatch(setSelectedTemplate({ templateId: null, view: null, filter: undefined }));
		// dispatch(resetScheduleReportError());
		dispatch(resetFirstTimeUsrStatus());
		dispatch(resetRowCountObject());
		dispatch(resetPivotOptions());
		navigate('/');
	};

	const cbOnWarningDialogCancel = () => {
		setOpenWarningDialog(false);
	};

	const ShowWarningDialogBox = () => {
		const dialogProps = {
			title: BACK_WARN_NOTE,
			bodyContent: BACK_WARN_MSG,
			secondaryBtnText: CONTINUE,
			primaryBtnText: CANCEL_BUTTON,
			onSecondaryClick: cbOnWaningDialogOkay,
			onPrimaryClick: cbOnWarningDialogCancel
		};

		return <DialogBox open={openWarningDialog} {...dialogProps} />;
	};

	const cbOnErrorDialogOkay = () => {
		dispatch(resetRowCountObject());
		setOpenErrorDialog(false);
	};

	const ShowErrorDialogBox = () => {
		let dialogProps = {
			title: '',
			bodyContent: openErrorDialog.msg,
			primaryBtnText: OK,
			secondaryBtnText: '',
			onPrimaryClick: cbOnErrorDialogOkay
		};
		dialogProps.hidePrimaryBtn = true;

		return <DialogBox open={openErrorDialog.open} {...dialogProps} />;
	};

	const cbOnShareDialogOkay = () => {
		handleShareDiscard();
	};

	const cbOnShareDialogCancel = () => {
		setShowInviteDiscardMsg(false);
	};

	const ShowShareReportDialog = () => {
		let dialogProps = {
			title: '',
			bodyContent: DISCARD_WARNING,
			secondaryBtnText: DISCARD,
			primaryBtnText: CANCEL_BUTTON,
			onSecondaryClick: cbOnShareDialogOkay,
			onPrimaryClick: cbOnShareDialogCancel
		};

		dialogProps.hideTitle = true;

		return <DialogBox open={showInviteDiscardMsg} {...dialogProps} />;
	};

	const endDateErrorText = endReportType === 'By' ? END_DATE_ERROR : OCCURRENCE_ERROR;

	const getError = () => {
		if (rowCount === 0) {
			return ZERO_ROWS;
		}
		return CSV_ROWS_EXCEED;
	};

	const getErrorTooltip = () => {
		if (rowCount === 0) {
			return ZERO_ROWS_TOOLTIP;
		}
		if (isCannedReport && rowCount > VENDOR_SCORECARD_MAX_ROW_COUNT) {
			return VENDOR_SCORECARD_MAX_ROW_COUNT_TOOLTIP;
		}
		if (customerType === BASIC && STR_TMPT_LIST.includes(Number(selectedTemplate))) {
			if (rowCount > MAX_CSV_ROW_COUNT) {
				return (
					<>
						<pre style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
							{BASIC_SSI_TOOLTIP_INVALID_REPORT}
						</pre>
						<pre style={{ marginBottom: 0 }}>
							<b>{BASIC_SSI_TOOLTIP_MAX_COUNT}</b>
						</pre>
						{BASIC_SSI_TOOLTIP_ALLOWED_TEMP}
					</>
				);
			} else {
				return (
					<>
						<pre style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
							<b>{BASIC_SSI_TOOLTIP_MAX_COUNT}</b>
						</pre>
						{BASIC_SSI_TOOLTIP_ALLOWED_TEMP}
					</>
				);
			}
		}
		if (customerType === CHARTER) {
			return (
				<>
					<pre style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
						<b>{CHARTER_TOOLTIP_MAX_COUNT}</b>
					</pre>
					{CHARTER_TOOLTIP_ALLOWED_TEMP}
				</>
			);
		}
		return CSV_ROWS_EXCEED_TOOLTIP;
	};

	/**
	 * Row count component
	 */

	const rowCountComp = () => {
		if (disableRowCount) {
			return null;
		}
		/**
		 * Display error in case:
		 * 1. rowCount > 10000000
		 * 2. rowCount = 0
		 * 3. Canned report with rowCount > 15000
		 */
		const isError =
			rowCount > MAX_CSV_ROW_COUNT ||
			rowCount === 0 ||
			(isCannedReport && rowCount > VENDOR_SCORECARD_MAX_ROW_COUNT);

		/**
		 * For Basic user if SSI template is being used then show info icon with tooltip beside rowCount message
		 */
		const isBasicUserWithSSI =
			customerType === BASIC && STR_TMPT_LIST.includes(Number(selectedTemplate));

		return (
			<Box display="flex" alignItems="center">
				<InputLabel className={isError ? classes.errorFont : classes.fontStyleTwo}>
					{isError ? getError() : showRowCountMsg()}
				</InputLabel>
				{bouncer}
				{checkMark}
				{(isError || isBasicUserWithSSI || customerType === CHARTER) && (
					<Tooltip
						arrow
						title={getErrorTooltip()}
						placement={isSmallScreen ? 'bottom' : 'right'}
						classes={{ tooltip: classes.tooltip }}>
						<IconButton
							aria-label="delete"
							className={isBasicUserWithSSI ? classes.infoIconNormalBtn : ''}>
							<InfoOutlinedIcon className={isError ? classes.infoIcon : classes.infoIconNormal} />
						</IconButton>
					</Tooltip>
				)}
			</Box>
		);
	};

	// Warning message for Max Reports creation
	// Run Once - AdhocReport
	// Run Continuously - ScheduledReport
	let maxReportCreationWarningMessage = null;
	if (canUserCreateReportCheckEnabled) {
		const warningMsg = (
			<Alert severity="error" className={classes.warnMsg} variant="outlined">
				{WARNING_MAX_REPORT_CREATION}
			</Alert>
		);
		if (btnSelected === 'once' && !canCreateAdhocReports) {
			maxReportCreationWarningMessage = warningMsg;
		} else if (btnSelected === 'continuous' && !canCreateScheduledReports) {
			maxReportCreationWarningMessage = warningMsg;
		}
	}
	// Submit button text
	let submitBtnText = rowCount === undefined ? CALCULATING : getButtonName();
	if (disableRowCount) {
		submitBtnText = getButtonName();
	}

	if (isLoading) {
		return <LoadingPage />;
	}

	const shouldDisplayDeliverTime =
		!FY24_CANNED_REPORT_LIST.includes(Number(selectedTemplate)) &&
		!VENDOR_SCORECARD_2025_LIST.includes(Number(selectedTemplate));

	return (
		<>
			<Box>
				<PreviewDialog
					open={showCaptchaDialogErrorBox}
					hidePrimaryBtn={true}
					hideSecondaryBtn={true}
					bodyContent={<PerimeterXCaptcha />}
				/>
				<AppBar position="fixed" id="app-bar" className={classes.appBar}>
					<Toolbar className={classes.toolbar}>
						<IconButton id="toolbar-back" size="small" onClick={handleBack} aria-label="back">
							<ChevronLeftIcon fontSize="large" />
						</IconButton>
						<InputLabel className={classes.headerFont}>{REPORT}</InputLabel>
						{hideReportSharing ? (
							<Box sx={{ display: { xs: 'none', md: 'flex' } }} style={{ gap: 24 }}>
								<IconButton
									id="toolbar-close"
									size="small"
									onClick={handleClose}
									aria-label="close">
									<CloseIcon fontSize="medium" />
								</IconButton>
							</Box>
						) : (
							<Box sx={{ display: { xs: 'none', md: 'flex' } }}>
								{
									<IconButton
										id="toolbar-share"
										size="small"
										onClick={handleShare}
										aria-label="share">
										<GroupAddIcon fontSize="medium" />
									</IconButton>
								}
								<IconButton
									id="toolbar-close"
									size="small"
									onClick={handleClose}
									aria-label="close">
									<CloseIcon fontSize="medium" />
								</IconButton>
							</Box>
						)}
					</Toolbar>
				</AppBar>
				<Grid
					container
					className={classes.containerHeight}
					justifyContent="center"
					style={{ overflow: 'scroll', paddingBottom: '80px' }}>
					<Grid item xs={12} sm={8} md={6} lg={4} className={classes.panel}>
						<Grid item xs={12} sm={12}>
							<Box className={classes.fieldContainer}>
								<RbTextField
									value={reportName}
									onChange={(e) => handleReportName(e)}
									onBlur={(e) => checkReportName(e.target.value.toLowerCase().trim())}
									error={error.reportName}
									helperText={
										error.reportName ? (
											<>
												{errorMsg === BAD_CHARACTER_SET ? (
													<ErrorIcon style={{ color: ERROR, paddingRight: '10px' }} />
												) : null}
												<Typography
													component={'span'}
													fontSize="14px"
													fontFamily={Bogle_Light}
													style={{ lineHeight: '19.46px' }}>
													{error.reportName && errorMsg}
												</Typography>
											</>
										) : null
									}
									FormHelperTextProps={{ classes: { root: classes.reportNameError } }}
									maxLength={50}
								/>
							</Box>
							<Box className={classes.fieldContainer} ref={ref}>
								<RbTextField
									id="description"
									label="Description (Optional)"
									multiline
									error={error.description}
									value={reportDesc}
									helperText={
										error.description ? (
											<Box display="flex">
												<ErrorIcon style={{ color: ERROR, paddingRight: '10px' }} />
												<Typography fontSize="14px" fontFamily={Bogle_Light} lineHeight={19.46}>
													{error.description && errorMsgDescription}
												</Typography>
											</Box>
										) : null
									}
									minRows={3}
									onChange={(e) => handleReportDesc(e)}
									maxLength={500}
								/>
							</Box>
							<Box className={`${classes.fieldContainer} ${classes.spaceBetween}`}>
								<InputLabel className={classes.fontStyleOne}>{REPORT_FORMAT}</InputLabel>
								{/* Row count component */}
								{rowCountComp()}
							</Box>
							<Box className={classes.fieldContainer}>
								<RadioGroup
									aria-label="file-type"
									name="file-type"
									row
									id="file-type"
									value={file}
									onChange={handleFiletypeChange}>
									<RadioField item={fileType} rowCount={rowCount} file={file} />
								</RadioGroup>
							</Box>
							<WarnMsg />
							<StyledRadioGroupComp
								btnSelected={btnSelected}
								isSmallScreen={isSmallScreen}
								width={width}
								handleBtnClick={handleBtnClick}
							/>
							<Box
								style={{
									backgroundColor: '#F9F9F9',
									margin: '24px 16px 24px 16px',
									borderRadius: 8,
									padding: 16
								}}>
								<Typography style={{ fontSize: 14, fontWeight: 700, display: 'flex' }}>
									<AccessTimeIcon fontSize="small" style={{ marginRight: 8 }} />
									Dataset refresh schedule:
								</Typography>
								<SLA selectedView={selectedView} refreshTime={refreshTime} />
							</Box>
							<Box className={`${classes.fieldContainer} ${classes.spaceBetween}`}>
								<InputLabel className={classes.fontStyleOne}>{SCHEDULE}</InputLabel>
							</Box>
							<Box id="renderSchedules" className={classes.fieldContainerTrimBottom}>
								{renderSchedules(btnSelected)}
							</Box>
							{btnSelected === 'continuous' && shouldDisplayDeliverTime && (
								<DynamicScheduling
									setIsDynamicSelected={setIsDynamicSelected}
									isCustomDS={isCustomDataset(selectedTemplate)}
								/>
							)}
							{weeksSelected === CUSTOM && scheduleType === 'Weekly' && (
								<Box className={`${classes.fieldContainer} ${classes.spaceBetween}`}>
									<Weekdays
										setWeeks={setWeeks}
										weeks={weeks}
										isOnlySingleDayAllowed={isDailyOptionDisabled()}
									/>
								</Box>
							)}
							<Box className={classes.dateContainer} id="schedule">
								<Schedule
									style={{ overflow: 'scroll' }}
									scheduleType={scheduleType}
									setSelectedDate={setSelectedDate}
									selectedDate={selectedDate}
									weeksSelected={weeksSelected}
									setWeeksSelected={setWeeksSelected}
									dateSelect={dateSelect}
									setDateSelect={setDateSelect}
									selectQuarter={selectQuarter}
									setSelectQuarter={setSelectQuarter}
									setCronExpression={setCronExpression}
									weeks={weeks}
									dropDownForWeeks={!isDailyOptionDisabled()}
									isDynamicSelected={isDynamicSelected}
								/>
								{error.frequency && (
									<Box className={classes.errorContainer}>
										<FormHelperText className={classes.reportNameError}>
											{SCHEDULE_ERROR}
										</FormHelperText>
									</Box>
								)}
							</Box>

							{runContinously.map((item) => item.label).includes(scheduleType) && (
								<>
									<Box className={`${classes.fieldContainer} ${classes.spaceBetween}`}>
										<InputLabel className={classes.fontStyleOne}>{END_REPORT}</InputLabel>
									</Box>
									<Box className={classes.fieldContainer}>
										<EndReport
											endReportType={endReportType}
											setReportType={setReportType}
											setEndDate={setEndDate}
											endDate={endDate}
											occurance={occurance}
											setOccurance={setOccurance}
											showError={showError}
											error={error}
										/>
									</Box>
									{error.eDate && (
										<Box className={classes.errorContainer}>
											<FormHelperText className={classes.reportNameError}>
												{endDateErrorText}
											</FormHelperText>
										</Box>
									)}
								</>
							)}
							<Box className={`${classes.fieldContainer} ${classes.spaceBetween}`}>
								<InputLabel className={`${classes.text} ${classes.black}`}>{NOTIFY}</InputLabel>
								<Switch
									checked={isEmailOpted}
									color="primary"
									onChange={() => setIsEmailOpted(!isEmailOpted)}
									inputProps={{ 'aria-label': 'is email opted' }}
								/>
							</Box>
							{maxReportCreationWarningMessage}
						</Grid>
					</Grid>
				</Grid>
				<Box className={classes.footerHeight}>
					<Grid item xs={12} sm={8} md={6} lg={4} className={classes.panel}>
						<Box className={classes.spaceBetween}>
							<Button
								id="btn-create"
								disabled={isDisabled || uuid === undefined}
								className={classes.create}
								variant="contained"
								color="primary"
								onClick={handleScheduleCreate}>
								{submitBtnText}
							</Button>
						</Box>
					</Grid>
				</Box>
				<ShowWarningDialogBox />
				<ShowErrorDialogBox />
			</Box>
			<ShareReport
				data={editData}
				show={shareReportShow}
				setShow={setShareReportShow}
				syncWithBE={false}
				setSharedWith={setSharedWith}
				handleBack={handleShareReportPanelClose}
			/>
			<ShowShareReportDialog />
		</>
	);
}

ReportSettings.propTypes = {};
ReportSettings.matcher = new RegExp('[&*,<>\\[\\]/\\\\"\']');

export default ReportSettings;
